export default "__VITE_ASSET__Bt4I15s___"